import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { PPE, IMAGES } from "@/data/site";
import { Icon } from "@/lib/Icon";
import { Reveal, stagger, item } from "@/lib/motionPrimitives";

export default function Safety() {
  return (
    <section id="safety" className="relative overflow-hidden bg-[#0A0A0A] py-24 md:py-32 text-white" data-testid="safety">
      <img
        src={IMAGES.safety}
        alt="Worker in PPE"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/85 to-[#0A0A0A]/40" />

      <div className="container-x relative z-10">
        <div className="grid gap-14 lg:grid-cols-2 lg:items-center">
          <div>
            <Reveal>
              <p className="text-xs font-bold uppercase tracking-[0.25em] text-primary font-display">Safety First</p>
              <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
                Strict Safety Standards On Every Site
              </h2>
              <p className="mt-5 max-w-lg text-white/75 leading-relaxed">
                We follow strict safety standards and ensure the use of safety belts and proper PPE on every site.
                Working at height in demanding industrial environments demands discipline — and we never compromise.
              </p>
              <div className="mt-6 inline-flex items-center gap-3 rounded-full border border-white/20 bg-white/5 px-5 py-3 backdrop-blur">
                <ShieldCheck className="h-5 w-5 text-primary" />
                <span className="text-sm font-medium">100% PPE Compliance</span>
              </div>
            </Reveal>
          </div>

          <motion.div
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="grid grid-cols-2 gap-4 sm:grid-cols-3"
          >
            {PPE.map((p) => (
              <motion.div
                key={p.title}
                variants={item}
                data-testid={`ppe-${p.title}`}
                className="flex flex-col items-center gap-3 rounded-2xl border border-white/12 bg-white/5 p-6 text-center backdrop-blur transition-colors hover:border-primary"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground">
                  <Icon name={p.icon} className="h-6 w-6" />
                </span>
                <span className="text-sm font-medium">{p.title}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
